export default __webpack_public_path__ + "static/media/bin.cb466378.svg";